export default function getParameter(field) {
  let url = window.location.href
  field = field.replace(/[\[\]]/g, '\\$&')
  let regex = new RegExp('[?&]' + field + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
